import type { Props } from '@cencosud-cencommerce/paris-uikit/dist/molecules/Toast/Toaster';

import type { CartOutOfStockItem } from '@/modules/cart/domain/CartOutOfStockItem';
import type { SendGtmEvent } from '@/modules/shared/utils/gtmEvents/buyNowTypes';
import {
  BuyNowEventInteractiveActions,
  BuyNowEventInteractiveCategories,
  BuyNowEventInteractiveTags
} from '@/modules/shared/utils/gtmEvents/buyNowTypes';

type ToastProps = Props;

export const HEADER_TITLE = 'Producto no disponible';
export const LABEL_SAVE = 'Guardar';
export const LABEL_EXPLORE_PRODUCTS = 'Explorar productos similares';
export const LABEL_PRODUCT_WILL_BE_REMOVED =
  'Al salir de esta página, el producto se eliminará. ';
export const LABEL_KEEP_FOR_LATER =
  'Guárdalo para después o explora productos similares.';

const TOAST_SAVE_SUCCESS_TITLE = '¡Genial! Guardaste tu producto con éxito';
const TOAST_SAVE_SUCCESS_BODY = 'Puedes verlo en tu carro.';
const TOAST_SAVE_ERROR_TITLE = 'No pudimos guardar este producto.';
const TOAST_SAVE_ERROR_BODY = 'Por favor, intenta de nuevo.';
const TOAST_AUTO_CLOSE = 5000;

export const TOAST_SAVE_SUCCESS: ToastProps = {
  title: TOAST_SAVE_SUCCESS_TITLE,
  body: TOAST_SAVE_SUCCESS_BODY,
  status: 'success',
  autoClose: TOAST_AUTO_CLOSE
};

export const TOAST_SAVE_ERROR: ToastProps = {
  title: TOAST_SAVE_ERROR_TITLE,
  body: TOAST_SAVE_ERROR_BODY,
  status: 'error',
  autoClose: TOAST_AUTO_CLOSE
};

export const SAVE_PRODUCT_EVENT: SendGtmEvent = {
  event: 'baseEvent',
  extraFields: {
    'event-interactive-tag': BuyNowEventInteractiveTags.SinStockGuardarProducto
  }
};

export const EXPLORE_PRODUCTS_EVENT: SendGtmEvent = {
  event: 'baseEvent',
  extraFields: {
    'event-interactive-tag':
      BuyNowEventInteractiveTags.SinStockExplorarProductos
  }
};

export const CLOSE_MODAL_EVENT: SendGtmEvent = {
  event: 'baseEvent',
  extraFields: {
    'event-interactive-tag': BuyNowEventInteractiveTags.SinStockCerrarModal
  }
};

export const buildEventOutOfStock = (
  product: CartOutOfStockItem
): SendGtmEvent => {
  const sku = product?.sku;
  const seller = product?.sellers?.[0];

  const vendedor = seller?.toLowerCase().includes('paris')
    ? 'paris'
    : 'marketplace';

  return {
    event: 'baseEvent',
    extraFields: {
      'event-interactive-category':
        BuyNowEventInteractiveCategories.CheckoutShipping,
      'event-interactive-accion': BuyNowEventInteractiveActions.Respuesta,
      'event-interactive-tag': BuyNowEventInteractiveTags.SinStockPantalla,
      'event-interactive-grupo_despacho': '1 - 1', // buy now always has 1 shipping group
      'event-interactive-vendedor': vendedor,
      'event-interactive-sku': sku
    }
  };
};
